import React from "react";
import RootTimesheetWorkerReview from "../../../screens/user/TimesheetWorkerReview";
import VStack from "../../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing/react";
import { buildBreakdown, buildMission, buildTimesheet } from "../../factories";
import { GET_DURATION_BREAKDOWN, GET_TIME_SHEET } from "../../../graphql/timesheet";
import { GET_MISSION } from "../../../graphql/core";
import { TimeSheetState } from "../../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";

const StoryComponent = () => {
    const mocks = [
        {
            request: {
                query: GET_TIME_SHEET,
                variables: () => true,
            },
            result: () => ({
                data: {
                    getTimeSheet: buildTimesheet({ status: TimeSheetState.Submitted }),
                },
            }),
        },
        {
            request: {
                query: GET_MISSION,
                variables: () => true,
            },
            result: () => ({
                data: {
                    getMission: buildMission(),
                },
            }),
        },
        {
            request: {
                query: GET_DURATION_BREAKDOWN,
                variables: () => true,
            },
            result: () => ({
                data: {
                    getDurationBreakdown: buildBreakdown(),
                },
            }),
        },
    ];
    return (
        <MockedProvider mocks={mocks}>
            <VStack alignment="stretch" style={{ flex: 1 }}>
                {/* @ts-expect-error Component need a complex navigation handler */}
                <RootTimesheetWorkerReview route={{ params: { id: "test" } }} />
            </VStack>
        </MockedProvider>
    );
};

const meta = {
    title: "Timesheet/Worker review",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
